import { Badge } from '@fluentui/react-components';
import { TERMINOLOGY } from '@shared/i18n';

type TProps = {
  isBound: boolean;
};

const BindingModeBadge = ({ isBound }: TProps) => (
  <Badge
    appearance="tint"
    color="informative"
    size="small"
    className={isBound ? '!bg-templateField/[0.12] !text-templateField' : ''}
  >
    {isBound ? TERMINOLOGY.bound.upper : TERMINOLOGY.detached.upper}
  </Badge>
);

export { BindingModeBadge };
